export default () => {
    return `<div class="banner contain-bg">
    <div class="background">
        <div class="bg-img"></div>
    </div>
    </div>`
}